<template>
  <div>
    <app-cells>
      <h1 class="title">Briefing & Eq. check</h1>
    </app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ClimbingBriefingsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'climbing-briefings-list', label: 'Briefings', roles: [] },
        { name: 'climbing-briefings-clients', label: 'Clients', roles: ['general_manager', 'operations_supervisor', 'finance_manager'] },
        { name: 'climbing-briefings-schedule', label: 'Schedule', roles: ['general_manager', 'operations_supervisor', 'finance_manager'] },
      ],
      tabs_to_show: [],
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    const tabs = []
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        tabs.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
      })
    })
    this.tabs_to_show = tabs
  },
}
</script>
